// 🛠️ Iter. 362 — Emergent engineering audit fix.
// The previous implementation imported `useTheme` from `next-themes`, but this
// app is a CRA (Create React App), not a Next.js app, and ThemeProvider is not
// mounted. The hook returned `undefined`, which subtly broke the toast theme
// and (combined with the `duration: Infinity` calls on Dashboard.js) caused
// the toasts to stick on screen across navigation.
// Hard-code `theme = 'dark'` to match the YUMIX Clean & Glow palette.
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const theme = "dark"

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
